import { findColor } from '../colors/colors';

export default class FPDLoaderTools {
	constructor() {
		
	}

	load_order(setProductId, setColors, setSelectedShirtColor, setDesigns, canvas, loadSide, setLoadingFPDData, oid) {
		setLoadingFPDData(true);
		if(oid !== ""){
			fetch(`/api/load-fpd?orderItemId=${oid}`).then(res => res.json()).then(fpd_data => {
				//console.log(fpd_data);
				setProductId(fpd_data.product[0].productTitle);
				fetch(`/api/colors?productId=${fpd_data.product[0].productTitle}`).then(res => res.json()).then(data => {
					setColors(data);
					if (data && data.length > 0) {
						// The order names its colour; if the product no longer
						// offers it, fall back to the first one. Passing an
						// unresolved name on to loadSide left it with no image
						// to draw, and the colour saved would not have matched
						// the canvas either.
						const colorObj = findColor(data, fpd_data.product[0]['elements'][0]['title']) || data[0];
						setSelectedShirtColor(colorObj.color);
						const sides = {
							"front": [],
							"back": [],
							"left": [],
							"right": []
						};
						//Front
						if(fpd_data.product[0]['elements'].length > 1){
							//console.log(fpd_data.product[0]['elements']);
							fpd_data.product[0]['elements'] = fpd_data.product[0]['elements'].slice(1);
							//console.log(fpd_data.product[0]['elements']);
							fpd_data.product[0]['elements'].forEach(element => {
								const part = element.parameters;
								part.type = element.type;
								part.src = element.source;
								sides.front.push(part);
							});
						}
						//Left
						if(fpd_data.product[1]['elements'].length > 1){
							fpd_data.product[1]['elements'] = fpd_data.product[1]['elements'].slice(1);
							fpd_data.product[1]['elements'].forEach(element => {
								const part = element.parameters;
								part.type = element.type;
								part.src = element.source;
								sides.left.push(part);
							});
						}
						//Right
						if(fpd_data.product[2]['elements'].length > 1){
							fpd_data.product[2]['elements'] = fpd_data.product[2]['elements'].slice(1);
							fpd_data.product[2]['elements'].forEach(element => {
								const part = element.parameters;
								part.type = element.type;
								part.src = element.source;
								sides.right.push(part);
							});
						}
						//Back
						if(fpd_data.product[3]['elements'].length > 1){
							fpd_data.product[3]['elements'] = fpd_data.product[3]['elements'].slice(1);
							fpd_data.product[3]['elements'].forEach(element => {
								const part = element.parameters;
								part.type = element.type;
								part.src = element.source;
								sides.back.push(part);
							});
						}
						setDesigns(sides);
						//console.log(sides['front'])
						loadSide(canvas, sides['front'], 'front', fpd_data.product[0].productTitle, colorObj);
					}
				});
			});
		}
	}
}


